import { ProuniApplication, ProuniEligibility } from './types';

export interface ProuniState {
  application: ProuniApplication | null;
  eligibility: ProuniEligibility | null;
}

const state: ProuniState = {
  application: null,
  eligibility: null,
};

export default state;
